export async function fetchDailySummary(weatherData = null) {

    const conditionsText = weatherData && Object.keys(weatherData).length > 0
        ? `
Daily conditions:
- Average pollen: ${weatherData.average_pollen ?? 'unknown'}
- Birch pollen: ${weatherData.birch_pollen ?? 'unknown'}
- Grass pollen: ${weatherData.grass_pollen ?? 'unknown'}
- Humidity: ${weatherData.humidity ?? 'unknown'}
- UV index: ${weatherData.uv_index ?? 'unknown'}
- AQI: ${weatherData.european_aqi ?? 'unknown'}
- Data freshness: ${weatherData.note ?? 'fresh'}
`
        : 'No daily conditions available. Generate advice based on general allergy and asthma best practices.';

    const message = `
    Use available user data if present.

    Daily conditions:
    ${conditionsText}

    IMPORTANT:
    If calendar/posts/profile are missing or unavailable,
    DO NOT say you found nothing. Always respond in danish, unless you are expressly parsed a different language preference from the user profile.

    Still generate a useful daily health summary
    based on the provided conditions.

    Keep responses brief, with no fluff. Information regarding pollen risk, weather impacts, and health advice should be concise and actionable. As a default, aim for 50 words. Only elaborate further There is important and demi-urgent information from personal user data
    Daily weather conditions and pollen data are already displayed underneath, so do not recite, but point out anything out of the ordinary where useful insight can be provided.

    Include:
    - pollen risk
    - weather impacts
    - asthma/allergy advice
    - humidity / AQI / UV considerations
    `;

    const token = localStorage.getItem('token');

    const res = await fetch('/api/chat', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify({ message }),
    });

    if (!res.ok) {
        throw new Error('Failed to fetch daily summary');
    }

    const data = await res.json();

    return data?.content?.[0]?.text || data?.reply || '';
}